import React from 'react';

type SidebarPanelProps = {
  title: string;
  children: React.ReactNode;
};

/**
 * BaseSidebarPanel - Wrapper for inspector panel content
 * Provides consistent padding and title styling matching Services/Team pattern
 */
export default function BaseSidebarPanel({ title, children }: SidebarPanelProps) {
  return (
    <div className="p-6">
      <h3 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-4">
        {title}
      </h3>
      <div className="space-y-6">
        {children}
      </div>
    </div>
  );
}

/**
 * SectionHeader - Standardized section header for use within panels
 * Matches the pattern used in Services/Team sections
 */
type SectionHeaderProps = {
  icon?: React.ComponentType<{ className?: string }>;
  children: React.ReactNode;
};

export function SectionHeader({ icon: Icon, children }: SectionHeaderProps) {
  return (
    <div className="flex items-center gap-2 mb-3">
      {Icon && <Icon className="w-4 h-4 text-muted-foreground" />}
      <h4 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        {children}
      </h4>
    </div>
  );
}
